export const blockIconsHomeEarlyOnNew = (
	<span className='material-symbols-outlined'>early_on</span>
);
